import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "maincontainer py-8 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Tasks")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "flex mt-4"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, "Task number"),
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, "Task Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, "Created")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "Open", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.tasks.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("table", null, [
                _hoisted_5,
                (_ctx.tasks.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task, taskIndex) => {
                        return (_openBlock(), _createElementBlock("tr", { key: taskIndex }, [
                          _createElementVNode("td", {
                            onClick: ($event: any) => (_ctx.editTask(task._id)),
                            class: "cursor-pointer"
                          }, _toDisplayString(task.taskName), 9, _hoisted_7),
                          _hoisted_8,
                          _createElementVNode("td", null, _toDisplayString(task.createdAt), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}